<p-fieldset>
  <p-header class="article-title">
    <span class="article-title">{{'TITLE-MOVEMENT-GROUP-CONFIG' | translate}}</span>
  </p-header>
  <app-movement-group></app-movement-group>
</p-fieldset>
